export const isSubscriptionExpired = (endDate?: Date | string | null): boolean => {
    if (!endDate) return true;

    const date = endDate instanceof Date ? endDate : new Date(endDate);

    if (isNaN(date.getTime())) return true;

    return date.getTime() < Date.now();
};
